module.exports = __webpack_public_path__ + "static/coding-jewels-std-logo-838cc337141322fd521984d1536d275f.png";